import * as R from 'ramda';

export const isValidRechargeNum: (_: string) => boolean =
  num => {
    const is13or17: (_: any) => boolean = R.flip(R.includes)([13, 17]);
    const onlyDigits = R.replace(/\D/g, '');
    const getLength = R.prop('length');
    const isValid = R.pipe(
      onlyDigits,
      getLength,
      is13or17
    );
    
    // This is a lame fix-up to prevent attempts to save recharge numbers that are too long.
    // The better fix is to store recharge numbers in normalized form, but that may break other
    // things and we're not going to maintain this codebase long-term.
    return isValid(num) && num.length <= 21;
  }

export function isValidCcoaNum( num: string ): boolean {
  const segments = num.split('.');
  if (segments.length < 5) return false;
  if (segments.length > 9) return false; // Max 9 segments (5 required + 4 optional)
  
  const [entity, fund, fru, account, purpose, ...optionalSegments] = segments;
  if (entity !== '1811') return false;
  if (!/^\d{5}$/.test(fund)) return false;
  if (!/^\d{7}$/.test(fru)) return false;
  if (!/^\d{6}$/.test(account)) return false;
  if (!/^\d{2}$/.test(purpose)) return false;

  const [program, project, activity, campusCommitment] = optionalSegments;
  if (program !== undefined && (!/^[a-zA-Z0-9]{3}$/.test(program))) return false;
  if (project !== undefined && (!/^[a-zA-Z0-9]{7}$/.test(project))) return false;
  if (activity !== undefined && (!/^[a-zA-Z0-9]{6}$/.test(activity))) return false;
  if (campusCommitment !== undefined && (!/^[a-zA-Z0-9]{5}$/.test(campusCommitment))) return false;
  
  return true;
}
